
import { defineComponent } from 'vue';
import taskExample from './classTask';
function mousedownHandler(target: any) {
    if (target.key === 'Enter') {
        taskExample.addTask();
    }
    return false;
}
export default defineComponent({
    name: 'App',
    setup() {
        const {task, inputValue, delSelect, taskSelect } = taskExample.values();
        window.addEventListener('keydown', mousedownHandler);
        return {
            taskExample,
            task,
            inputValue,
            delSelect,
            taskSelect,
        }
    }
});
